import { render, staticRenderFns } from "./LoopItemPanel.vue?vue&type=template&id=584ad2ea&scoped=true&"
import script from "./LoopItemPanel.vue?vue&type=script&lang=js&"
export * from "./LoopItemPanel.vue?vue&type=script&lang=js&"
import style0 from "./LoopItemPanel.vue?vue&type=style&index=0&id=584ad2ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584ad2ea",
  null
  
)

export default component.exports